const HASH = process.env.NEXT_PUBLIC_CLOUDFLARE_IMAGES_ACCOUNT_HASH

module.exports = function cloudflarePhoto (imageId, variant) {
    return `https://imagedelivery.net/${HASH}/${imageId}/${variant}`
}